import React, { useRef } from 'react';
import Helmet from 'react-helmet';
import Moment from 'moment';
import _ from 'lodash';
import { Box, Link, Stack } from '@mui/material';
import Scroller from '../components/Scroller';
import { FieldService } from '../services/Fields';
//import { NotificationService } from '../services/Notification';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import { WorkScheduleService } from '../services/Works';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { APPROVAL_FILE_TYPE, DATE_TIME_FORMAT, FILE_EXTENSION_ID } from '../utilities/constants';
import WorkDatesService from '../services/WorkDates';
import {
  HEADER_CONSTANTS,
  RECOVERY_FLAG,
  API_FLAG,
  FIELD_COMPLETE_STATUS,
  USER_ROLES,
} from '../utilities/constants';
import { getFieldStatus } from '../utilities/fieldUtil'; // BLDE_V2-47892：現場のステータスを取得する
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import _slideLoader from '../utilities/slideLoader';
import {
  getSafetyDiaryDetailPageName,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import { ConferencePageHeader } from '../components/PageHeader';
import urlParamManager from '../utilities/urlParamManager';
import SessionStorageService from '../services/utilities/SessionStorageService';
import Auth from '../components/Auth';
import UnapprovedWorksPageHeader from '../components/UnapprovedWorksPageHeader';
import CommonModal from '../components/modals/common/Modal';
import { ImageDialog } from '../components/modals/ImageDialog';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';
import { FormInformationDialog } from '../components/FormInformationDialog';
import regex from '../utilities/validateRegex';
import { Confirmation } from '../components/modals/common';
import { messageUtility } from '../utilities/messageUtility';
import IconCreate from '../images/icon/icon--add.svg';
import dialogLoader from '../utilities/dialogLoader';
import { DialogTitle } from './modals/Commons';
import { FieldUrlsService } from '../services/FieldUrls';
import { FieldFilesService } from '../services/FieldFiles';
import { deleteControlCode } from '../utilities/stringUtil';
import ImageUtility from '../utilities/imageUtility';
import PrintUtility from '../utilities/printUtility';

const JOURNAL_TYPE = SafetyDiariesConstants.journalType; // 記入者(元請ユーザー)
const DATE_TYPE = SafetyDiariesConstants.dataType; // 期間
const REPORT_TYPE = SafetyDiariesConstants.reportType; // 種別
const URGENCY_TYPE = SafetyDiariesConstants.urgencyType; // 緊急度

const MAX_LENGTH = {
  label: 255,
  url: 512,
};

const FILE_NAME_TAIL = -7;

/**
 * @description ダッシュボード
 */
export class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenListFieldFiles: false,
      isOpenListFieldUrls: false,
      fieldId: SessionStorageService.getFieldId(),
      fieldData: {},
      worker: {
        scheduled: 0,
        achivement: 0,
      },
      date_from:
        SessionStorageService.getItem('date_from') ||
        Moment().format(DATE_TIME_FORMAT.slashDateFormat),
      date_to:
        SessionStorageService.getItem('date_to') ||
        Moment().format(DATE_TIME_FORMAT.slashDateFormat),
      work_hour_zone: SessionStorageService.getItem('work_hour_zone') || '0',
      fieldUrls: [],
      fieldFiles: [],
      patrolDataList: [],
      isWorkDateSet: true, // 稼働日が設定されるかどうか
      isFieldCompleted: false, // Buildee利用終了日が過ごしたがどうか
      usePartnerCompanyApprovalFlag:
        SessionStorageService.getUsePartnerCompanyApprovalFlag() ===
        API_FLAG.On, // 協力会社承認機能ご利用フラグ
      fieldUrlsOrigin: [],
      fieldUrlsNew: [],
      fieldUrlsDeletedIds: [],
      isShowDialogFieldUrl: false,
      isLoading: false,
      fieldFilesOrigin: [],
      isShowDialogFilesUpload: false,
      fieldFilesNew: [],
    };
    this.roleId = LocalStorageService.getRoleId();
    this.isPrimaryCompanyRole = isPrimaryCompanyRoleId();
    this.isSubmitingFlag = false;
  }

  componentDidMount() {
    // eslint-disable-next-line no-unused-vars
    const params = {
      field_id: this.state.fieldId,
      work_hour_zone: this.state.work_hour_zone,
    };
    //NotificationService.registerUnentered(params).then();

    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const { field } = response.data.entities;
        this.setFieldData(field);
        // BLDE_V2-47892: Buildee利用終了日が過ごしたかどうかの確認
        this.checkFieldCompleted(field);
      }
    });
    // 稼働日設定をロード
    let isWorkDateNotSet = true;
    const monthIndex = [0, 1];
    let isMonthFilled = [false, false];
    monthIndex.map(i => {
      const dateCheck = Moment()
        .startOf('month')
        .add(i, 'months');
      const month = dateCheck.month() + 1;
      const year = dateCheck.year();
      const fieldId = SessionStorageService.getFieldId();
      const dateFrom = dateCheck.format(DATE_TIME_FORMAT.slashDateFormat);
      const dateTo = Moment(dateCheck)
        .endOf('month')
        .format(DATE_TIME_FORMAT.slashDateFormat);
      const params = {
        date_from: dateFrom,
        date_to: dateTo,
      };
      return WorkDatesService.list(fieldId, params).then(resp => {
        if (resp.result) {
          const date = Moment(`${year}/${month}/01`);
          const workDateList = [];
          const work_dates = resp.data.entities.work_dates;
          if ((Moment().isSame(Moment().month() + 1), 'day')) {
            const index = _.findIndex(work_dates, [
              'work_date',
              date.format(DATE_TIME_FORMAT.slashDateFormat),
            ]);
            if (index > -1) {
              workDateList.push(work_dates[index]);
            } else {
              workDateList.push({
                field_id: fieldId,
                work_date: date.format(DATE_TIME_FORMAT.slashDateFormat),
                holiday_flag: 0,
              });
            }
            date.add('day', 1);
          }
          // 稼働日設定が登録される場合
          _.forEach(workDateList, function(value) {
            if (value.created_at != null) {
              isMonthFilled[i] = true;
            }
          });
          // 当月分または来月分の稼働日が設定されない場合
          isWorkDateNotSet = !(isMonthFilled[0] && isMonthFilled[1]);
          this.setState({
            isWorkDateSet: isWorkDateNotSet,
          });
        }
      });
    });

    const { date_from, date_to } = this.state;
    WorkScheduleService.groupWorkHours(this.state.fieldId, {
      date_from,
      date_to,
      schedule_flag: 1,
      work_hour_zone: this.state.work_hour_zone,
    }).then(response => {
      if (response.result) {
        const worker = _.merge({}, this.state.worker, {
          scheduled: response.data.entities.work.man_hours,
        });
        this.setState({ worker });
      }
    });
    WorkScheduleService.groupWorkHours(this.state.fieldId, {
      date_from,
      date_to,
      schedule_flag: 0,
      work_hour_zone: this.state.work_hour_zone,
    }).then(response => {
      if (response.result) {
        const worker = _.merge({}, this.state.worker, {
          achivement: response.data.entities.work.man_hours,
        });
        this.setState({ worker });
      }
    });

    this.loadSafetyDiary();

    this.fetchFieldUrls();

    this.fetchFieldFiles();

    // 現状は1の場合しか表示していないので
    if (this.props.vw === '1') {
      urlParamManager.pageWillLoad(this.reOpenSlide);
    }
  }

  componentWillUnmount() {
    urlParamManager.removePageWillLoad(this.reOpenSlide);
  }

  reOpenSlide = (urlparam, masterparam, slide) => {
    // Slideを操作すると毎回呼ばれるのでDashboardを表示している場合のみ
    // 次の場合に巡回記録が更新されているかもしれないので再読み込みする
    // ・ 統括安全衛生責任者 - 各種巡回連絡から戻ってきた場合
    // ・ 通知から巡回記録に遷移して戻ってきた場合
    if (
      _.get(urlparam, '[0]') === 'Dashboard:1' &&
      // Dashboardから他のSlideを開いていないことの確認
      _.toString(_.get(slide, '[0]')) === '0'
    ) {
      this.loadSafetyDiary();
    }
  };

  loadSafetyDiary = () => {
    SafetyDiaryService.searchList(this.state.fieldId, {
      date_type: 1,
      journal_types: [JOURNAL_TYPE.generalSafety.id],
      // ダッシュボードで使うかどうか(APIに余計な処理をさせないため)
      is_dash_board: 1,
    }).then(response => {
      if (!response.result) {
        return;
      }
      const safetyDiaries = response.data.entities.safety_diaries;
      const dashBoardSafetyDiaries = _.filter(
        safetyDiaries,
        item => item.recovery_flag === RECOVERY_FLAG.incomplete.id
      );
      let sortedPatrolDataList = _.orderBy(
        dashBoardSafetyDiaries,
        ['type', 'entries_date'],
        ['asc', 'desc']
      );
      this.setState({ patrolDataList: sortedPatrolDataList });
    });
  };

  fetchFieldUrls = () => {
    FieldUrlsService.list(this.state.fieldId).then(response => {
      if (response.result) {
        const fieldUrls = response.data.entities.field_urls;
        this.setState({ fieldUrls });
      }
    });
  };

  fetchFieldFiles = () => {
    FieldFilesService.listFiles(this.state.fieldId).then(response => {
      if (response.result) {
        const fieldFiles = response.data.entities.field_shared_files;
        this.setState({ fieldFiles });
      }
    });
  };

  /**
   * 現場のデータをstateへセット
   *
   * @memberof Dashboard
   */
  setFieldData = fieldData => {
    // メインの元請がCO2有効か設定する
    SessionStorageService.setCo2ReportFlag(fieldData.use_co2_report_flag);
    this.setState({ fieldData });
  };
  /** Buildee利用終了日が過ごしたかどうかの確認するfunction
   * @param {object} fieldData 現場のデータ
   */
  checkFieldCompleted = fieldData => {
    const fieldStatus = getFieldStatus(fieldData);
    if (fieldStatus.ID === FIELD_COMPLETE_STATUS.EXPIRED.ID) {
      this.setState({ isFieldCompleted: true });
    }
  };

  setWorkerData = workerData => {
    this.setState({ worker: workerData });
  };

  handleCollapseListToggle = stateKey => {
    this.setState(prevState => ({
      [stateKey]: !prevState[stateKey],
    }));
  };

  renderPatrolLogByReportType = patrolData => {
    switch (patrolData.type) {
      case 1: {
        return this.renderPointedOut(patrolData);
      }
      case 2: {
        return this.renderInform(patrolData);
      }
      case 3: {
        return this.renderOthers(patrolData);
      }
      case 4: {
        return this.renderWorkCommunication(patrolData);
      }
      case 5: {
        return this.renderOtherCommunication(patrolData);
      }
      default: {
        break;
      }
    }
  };

  renderCommon = patrolData => {
    const ut = _.find(URGENCY_TYPE, ut => ut.id === patrolData.urgency);
    return (
      <li
        key={patrolData.id}
        className='textlist__item'
        onClick={() =>
          _slideLoader.show(
            getSafetyDiaryDetailPageName(patrolData),
            {
              state: {
                id: patrolData.id,
                dataId: patrolData.id,
                params: {
                  date_type: DATE_TYPE.entriesDate,
                  journal_types: [JOURNAL_TYPE.generalSafety.id],
                  is_dash_board: API_FLAG.On,
                },
              },
            },
            this.props.vw
          )
        }
      >
        <div className='label --fx-192'>
          {Moment(patrolData.created_at).format('YYYY/MM/DD HH:mm')}
        </div>
        <div className='label --fx-128'>
          <div
            className={`status--long${
              this.isImportantReport(patrolData.type) ? '--caution' : ''
            }`}
          >
            {this.reportType(patrolData.type)}
          </div>
        </div>
        <div className='label --fx-64'>
          <div
            className={`status--short${
              patrolData.urgency === URGENCY_TYPE.emergency.id
                ? '--caution'
                : ''
            }`}
          >
            {ut.name}
          </div>
        </div>
        <div
          className='label --fx-auto'
          style={{ width: '0%', textOverflow: 'ellipsis' }}
        >
          {patrolData.pointing_out_detail}
        </div>
      </li>
    );
  };

  renderPointedOut = patrolData => {
    return this.renderCommon(patrolData);
  };

  renderInform = patrolData => {
    if (Moment().isAfter(Moment(patrolData.end_date), 'day')) {
      return null;
    }
    return this.renderCommon(patrolData);
  };

  renderOthers = patrolData => {
    if (!Moment().isSame(Moment(patrolData.entries_date), 'day')) {
      return null;
    }
    return this.renderCommon(patrolData);
  };

  renderWorkCommunication = patrolData => {
    if (!Moment().isSame(Moment(patrolData.entries_date), 'day')) {
      return null;
    }
    return this.renderCommon(patrolData);
  };

  renderOtherCommunication = patrolData => {
    if (!Moment().isSame(Moment(patrolData.entries_date), 'day')) {
      return null;
    }
    return this.renderCommon(patrolData);
  };

  reportType = id => {
    const reportType = _.find(REPORT_TYPE, reportType => reportType.id === id);
    if (!reportType) {
      return '';
    }
    return reportType.name;
  };

  isImportantReport = id => {
    return id === 1;
  };

  handleOpenDialogFieldUrl = () => {
    this.setState({
      isShowDialogFieldUrl: true,
      fieldUrlsOrigin: [],
      isLoading: true,
    });
    FieldUrlsService.list(this.state.fieldId)
      .then(response => {
        if (!response.result) {
          return;
        }
        const fieldUrlsOrigin = _.get(response, 'data.entities.field_urls', []);
        this.setState({ fieldUrlsOrigin });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleOpenDialogFieldFile = () => {
    this.setState({
      isShowDialogFilesUpload: true,
      fieldFilesOrigin: [],
      fieldFilesNew: [],
      isLoading: true,
    });
    FieldFilesService.listFiles(this.state.fieldId)
      .then(response => {
        if (!response.result) {
          return;
        }
        const fieldFilesOrigin = _.get(
          response,
          'data.entities.field_shared_files',
          []
        );
        this.setState({ fieldFilesOrigin });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleAddFieldUrl = () => {
    this.setState(prevState => ({
      fieldUrlsNew: [
        ...prevState.fieldUrlsNew,
        {
          title: '',
          url: '',
          isEdited: true,
          weather_url_flag: false,
        },
      ],
    }));
  };

  handleChangeFieldUrl = (id, isNewUrl, key, value) => {
    const newValue = deleteControlCode(value);
    if (isNewUrl) {
      const fieldUrlsNew = _.cloneDeep(this.state.fieldUrlsNew);
      fieldUrlsNew[id][key] = newValue;
      this.setState({ fieldUrlsNew });
      return;
    }
    this.setState({
      fieldUrlsOrigin: _.map(this.state.fieldUrlsOrigin, url =>
        url.id === id ? { ...url, [key]: newValue } : url
      ),
    });
  };

  getValidateFieldUrls = (
    valueTitle,
    countTitleValue,
    valueUrl,
    isValidateAll = false
  ) => {
    let errorTitle = '';
    let errorUrl = '';
    if (!_.isNull(valueTitle)) {
      if (valueTitle === '') {
        errorTitle = '表示名を入力してください。';
      } else if (_.size(valueTitle) > MAX_LENGTH.label) {
        errorTitle = messageUtility.getMessage(
          'E-000-026',
          String(MAX_LENGTH.label)
        );
      } else if (countTitleValue > 1) {
        errorTitle = '同じ表示名があります。違う表示名を入力してください。';
      }
      if (!isValidateAll) {
        return errorTitle;
      }
    }
    if (!_.isNull(valueUrl)) {
      if (valueUrl === '') {
        errorUrl = 'URLを入力してください。';
      } else if (!regex.pattern.url.test(valueUrl)) {
        errorUrl = regex.message.url;
      } else if (_.size(valueUrl) > MAX_LENGTH.url) {
        errorUrl = messageUtility.getMessage(
          'E-000-026',
          String(MAX_LENGTH.url)
        );
      }
      if (!isValidateAll) {
        return errorUrl;
      }
    }
    return { errorTitle, errorUrl };
  };

  validateDuplicateUrl = (fieldUrlsNew, fieldUrlsOrigin) => {
    const listAllUrls = [...fieldUrlsNew, ...fieldUrlsOrigin];
    const listCountTitles = _.countBy(_.map(listAllUrls, 'title'));
    const msgDuplicate = '同じ表示名があります。違う表示名を入力してください。';
    _.forEach(listAllUrls, item => {
      if (
        item.title &&
        !(item.errorTitle && item.errorTitle !== msgDuplicate)
      ) {
        const countTitleValue = listCountTitles[item.title] || 0;
        item.errorTitle = countTitleValue > 1 ? msgDuplicate : '';
      }
    });
  };

  validateFieldUrl = (id, isNewUrl, key, value) => {
    const valueTrim = value.trim();
    const errorKey = key === 'title' ? 'errorTitle' : 'errorUrl';
    let errorMessage;
    if (key === 'title') {
      const titles = _.map(
        [...this.state.fieldUrlsNew, ...this.state.fieldUrlsOrigin],
        item => item.title.trim()
      );
      const countTitleValue = _.countBy(titles)[valueTrim] || 0;
      errorMessage = this.getValidateFieldUrls(
        valueTrim,
        countTitleValue,
        null
      );
    } else {
      errorMessage = this.getValidateFieldUrls(null, null, valueTrim);
    }

    const fieldUrlsNew = _.cloneDeep(this.state.fieldUrlsNew);
    let fieldUrlsOrigin = _.cloneDeep(this.state.fieldUrlsOrigin);
    const editedUrl = isNewUrl
      ? fieldUrlsNew[id]
      : _.find(fieldUrlsOrigin, { id });

    if (editedUrl) {
      editedUrl[errorKey] = errorMessage;
      editedUrl[key] = valueTrim;
    }
    if (key === 'title') {
      this.validateDuplicateUrl(fieldUrlsNew, fieldUrlsOrigin);
    }
    this.setState({ fieldUrlsNew, fieldUrlsOrigin });
  };

  handleEditFieldUrl = id => {
    this.setState({
      fieldUrlsOrigin: _.map(this.state.fieldUrlsOrigin, url =>
        url.id === id ? { ...url, isEdited: true } : url
      ),
    });
  };

  handleRemoveFieldUrl = (id, isNewUrl) => {
    const fieldUrlsNew = _.cloneDeep(this.state.fieldUrlsNew);
    const fieldUrlsOrigin = _.cloneDeep(this.state.fieldUrlsOrigin);
    const fieldUrlsDeletedIds = _.cloneDeep(this.state.fieldUrlsDeletedIds);
    if (isNewUrl) {
      _.pullAt(fieldUrlsNew, id);
    } else {
      _.remove(fieldUrlsOrigin, { id });
      fieldUrlsDeletedIds.push(id);
    }
    this.validateDuplicateUrl(fieldUrlsNew, fieldUrlsOrigin);
    this.setState({
      fieldUrlsNew,
      fieldUrlsOrigin,
      fieldUrlsDeletedIds,
    });
  };

  validateAllFieldUrls = () => {
    let isValid = true;
    const titles = _.map(
      [...this.state.fieldUrlsNew, ...this.state.fieldUrlsOrigin],
      item => item.title.trim()
    );
    const validateListUrls = urls =>
      _.map(urls, item => {
        const countTitleValue = _.countBy(titles)[item.title] || 0;
        const { errorTitle, errorUrl } = this.getValidateFieldUrls(
          item.title,
          countTitleValue,
          item.url,
          true
        );
        item.errorTitle = errorTitle;
        item.errorUrl = errorUrl;
        isValid = isValid && !errorTitle && !errorUrl;
        return item;
      });

    const fieldUrlsOrigin = validateListUrls(this.state.fieldUrlsOrigin);
    const fieldUrlsNew = validateListUrls(this.state.fieldUrlsNew);

    this.setState({ fieldUrlsOrigin, fieldUrlsNew });

    return isValid;
  };

  handleUpdateFieldUrl = async () => {
    if (!this.validateAllFieldUrls() || this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    let params = {};
    const {
      fieldId,
      fieldUrlsDeletedIds,
      fieldUrlsNew,
      fieldUrlsOrigin,
    } = this.state;
    if (!_.isEmpty(fieldUrlsDeletedIds)) {
      params.delete_url_ids = fieldUrlsDeletedIds;
    }
    if (!_.isEmpty(fieldUrlsNew)) {
      params.create_urls = _.map(fieldUrlsNew, item => ({
        title: item.title,
        url: item.url,
        weather_url_flag: item.weather_url_flag,
      }));
    }
    const update_urls = _.filter(fieldUrlsOrigin, 'isEdited');
    if (!_.isEmpty(update_urls)) {
      params.update_urls = _.map(update_urls, item => ({
        id: item.id,
        title: item.title,
        url: item.url,
        weather_url_flag: item.weather_url_flag,
      }));
    }
    if (_.isEmpty(params)) {
      this.isSubmitingFlag = false;
      this.handleCloseDialogFieldUrl();
      return;
    }
    const response = await FieldUrlsService.bulkUpdate(fieldId, params);
    this.isSubmitingFlag = false;
    this.handleCloseDialogFieldUrl();
    if (response.result) {
      this.fetchFieldUrls();
      return dialogLoader.show(DialogTitle, {
        title: messageUtility.getMessage('I-001-587'),
        buttonText: messageUtility.getMessage('I-000-008'),
        callbacks: () => {
          this.setState({ isOpenListFieldUrls: true });
          dialogLoader.close();
        },
      });
    }
    dialogLoader.show(DialogTitle, {
      title: messageUtility.getMessage('E-001-461'),
      buttonText: messageUtility.getMessage('I-000-008'),
      callbacks: () => window.location.reload(),
    });
  };

  handleCloseDialogFieldUrl = () => {
    this.setState({
      isShowDialogFieldUrl: false,
      fieldUrlsOrigin: [],
      fieldUrlsDeletedIds: [],
      fieldUrlsNew: [],
    });
  };

  handleUpdateFieldFiles = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const { fieldId, fieldFilesNew, fieldFilesOrigin } = this.state;
    const listFilesNew = _.map(fieldFilesNew, item => ({
      file_name: item.file_name,
      temp_file_key: item.temp_file_key,
    }));
    const listFileOrigins = _.map(fieldFilesOrigin, item => ({
      id: item.id,
      file_name: item.file_name,
      temp_file_key: item.temp_file_key,
    }));
    const params = { files: [...listFileOrigins, ...listFilesNew] };
    const response = await FieldFilesService.bulkUpdate(fieldId, params);
    this.isSubmitingFlag = false;
    this.handleCloseDialogFieldFiles();
    if (response.result) {
      this.fetchFieldFiles();
      return dialogLoader.show(DialogTitle, {
        title: messageUtility.getMessage('I-001-589'),
        buttonText: messageUtility.getMessage('I-000-008'),
        callbacks: () => {
          this.setState({ isOpenListFieldFiles: true });
          dialogLoader.close();
        },
      });
    }
    const message = _.get(response, 'data.message');
    const isShowModalUpdateSameTime =
      message === messageUtility.getMessage('E-001-463');
    if (isShowModalUpdateSameTime) {
      dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('E-001-402'),
        message,
        buttonText: messageUtility.getMessage('I-000-008'),
        onClose: () => window.location.reload(),
      });
    } else {
      dialogLoader.show(DialogTitle, {
        title: messageUtility.getMessage('E-001-462'),
        buttonText: messageUtility.getMessage('I-000-008'),
        callbacks: () => window.location.reload(),
      });
    }
  };

  handleCloseDialogFieldFiles = () => {
    this.setState({
      isShowDialogFilesUpload: false,
      fieldFilesOrigin: [],
      fieldFilesNew: [],
    });
  };

  splitArrayByIndex = data => {
    return [
      _.filter(data, (_, index) => index % 2 === 0),
      _.filter(data, (_, index) => index % 2 === 1),
    ];
  };

  renderFileListRows = listFiles => {
    return _.map(listFiles, ({ id, file_url, file_name, file_extension_id }) => {
      const filenameTail = file_name.slice(FILE_NAME_TAIL);
      const fileNameRemaining = file_name.slice(0, FILE_NAME_TAIL);
      return (
        <tr key={id} className='dashboard-table__tr'>
          <td className='dashboard-table__item'>
            <Link
              underline='none'
              href={file_url}
              target='_blank'
              className='text--positive'
              onClick={event => {
                if (file_extension_id === FILE_EXTENSION_ID.ETC) {
                  // excelファイルの場合は、リダイレクトが発生しないように、強制的にダウンロードさせる
                  event.preventDefault();
                  PrintUtility.downloadFilePresignedUrl(file_url, file_name);
                }
              }}
            >
              <Box
                className='dashboard-table__item--file-name-wrapper'
                maxWidth='fit-content'
                display='flex'
                whiteSpace='pre'
              >
                <span className='file-name-pre text--positive'>
                  {fileNameRemaining}
                </span>
                {filenameTail}
              </Box>
            </Link>
          </td>
        </tr>
      );
    });
  };

  renderURLListRows = listUrls => {
    return _.map(listUrls, (fieldUrl, index) => (
      <tr key={index} className='dashboard-table__tr'>
        <td className='dashboard-table__item'>
          <a className='clickable-text' href={fieldUrl.url} target='_blank'>
            {fieldUrl.title}
          </a>
        </td>
      </tr>
    ));
  };

  isDisabledSubmitFieldUrls = () =>
    _.some(
      [...this.state.fieldUrlsNew, ...this.state.fieldUrlsOrigin],
      item => item.errorTitle || item.errorUrl
    );

  getFieldTableBody = (isGetFieldUrls = true) => {
    const {
      fieldUrls,
      isOpenListFieldUrls,
      fieldFiles,
      isOpenListFieldFiles,
    } = this.state;
    const data = isGetFieldUrls ? fieldUrls : fieldFiles;
    const isOpen = isGetFieldUrls ? isOpenListFieldUrls : isOpenListFieldFiles;
    if (_.isEmpty(data)) {
      return {};
    }
    const dataToDisplay = isOpen ? data : _.slice(data, 0, 2);
    const [leftList, rightList] = this.splitArrayByIndex(dataToDisplay);
    if (isGetFieldUrls) {
      return {
        fieldUrlsLeftTableRows: this.renderURLListRows(leftList),
        fieldUrlsRightTableRows: this.renderURLListRows(rightList),
      };
    }
    return {
      fieldFieldsLeftTableRows: this.renderFileListRows(leftList),
      fieldFieldsRightTableRows: this.renderFileListRows(rightList),
    };
  };

  validateFieldFile = async file => {
    if (!file) {
      return false;
    }
    const isTypeResult = await ImageUtility.approvalFileType(
      file,
      APPROVAL_FILE_TYPE
    );
    const isSizeResult = await ImageUtility.fileSizeCheck(file);
    const validFileName = await ImageUtility.hasfileName(file);
    let messageValidate = '';
    if (!isTypeResult) {
      messageValidate = messageUtility.getMessage(
        'E-000-038',
        APPROVAL_FILE_TYPE
      );
    } else if (!isSizeResult) {
      messageValidate = messageUtility.getMessage('E-000-011');
    } else if (!validFileName) {
      messageValidate = messageUtility.getMessage('E-000-083');
    }
    if (messageValidate) {
      dialogLoader.show(
        WrappedImageDialog,
        {
          message: messageValidate,
          isCenterModal: true,
          callback: {
            confirm: () => {
              dialogLoader.close();
            },
          },
        },
        null
      );
      return false;
    }
    return true;
  };

  getUniqueFileName = (fileName, listFileNameExist) => {
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    const baseName = fileName.substring(0, fileName.lastIndexOf('.'));

    let newFileName = fileName;
    let counter = 1;

    while (_.includes(listFileNameExist, newFileName)) {
      newFileName = `${baseName}(${counter})${fileExtension}`;
      counter += 1;
    }

    return newFileName;
  };

  setFile = async (file, isNewFile = true, id = null) => {
    if (!(await this.validateFieldFile(file))) {
      return;
    }
    const fieldFilesOrigin = _.cloneDeep(this.state.fieldFilesOrigin);
    const fieldFilesNew = _.cloneDeep(this.state.fieldFilesNew);
    const listFileCurrent = [...fieldFilesOrigin, ...fieldFilesNew];
    const response = await FieldFilesService.tempFiles(
      this.state.fieldId,
      file
    );
    if (!response.result) {
      return;
    }
    const uniqueFileName = this.getUniqueFileName(
      file.name,
      _.map(
        _.isNil(id) ? listFileCurrent : _.reject(listFileCurrent, { id }),
        'file_name'
      )
    );
    const tempFileKey = _.get(response, 'data.entities.temp_file_key', '');
    const newFile = {
      id: _.uniqueId('file_new_'),
      file_name: uniqueFileName,
      temp_file_key: tempFileKey,
      size: file.size,
      lastModified: file.lastModified,
    };
    if (isNewFile && _.isNil(id)) {
      fieldFilesNew.push(newFile);
    } else {
      const existInFilesCurrent = _.find(listFileCurrent, { id });
      if (existInFilesCurrent) {
        existInFilesCurrent.file_name = newFile.file_name;
        existInFilesCurrent.temp_file_key = newFile.temp_file_key;
        existInFilesCurrent.file_url = '';
      }
    }
    this.setState({ fieldFilesOrigin, fieldFilesNew });
  };

  handleRemoveFile = (id, isNewFile) => {
    return dialogLoader.show(CancelAndConfirmDialog, {
      title: messageUtility.getMessage('I-001-590'),
      message: messageUtility.getMessage('I-001-591'),
      confirmButtonText: messageUtility.getMessage('I-000-018'),
      cancelButtonText: messageUtility.getMessage('I-000-017'),
      negativeButtonClassName: 'btn--negative--filled',
      isNegative: true,
      onConfirm: () => {
        const fieldFilesNew = _.cloneDeep(this.state.fieldFilesNew);
        const fieldFilesOrigin = _.cloneDeep(this.state.fieldFilesOrigin);
        _.remove(isNewFile ? fieldFilesNew : fieldFilesOrigin, { id });
        this.setState({
          fieldFilesNew,
          fieldFilesOrigin,
        });
        dialogLoader.close();
      },
      onCancel: () => {
        dialogLoader.close();
      },
    });
  };

  render() {
    const {
      fieldData,
      worker,
      fieldFilesNew,
      fieldFilesOrigin,
      usePartnerCompanyApprovalFlag,
      isOpenListFieldUrls,
      isOpenListFieldFiles,
    } = this.state;
    const {
      fieldUrlsLeftTableRows,
      fieldUrlsRightTableRows,
    } = this.getFieldTableBody();
    const {
      fieldFieldsLeftTableRows,
      fieldFieldsRightTableRows,
    } = this.getFieldTableBody(false);
    return (
      <div id='main' className='main'>
        {this.props.vw === '1' && (
          <Helmet>
            <title>{HEADER_CONSTANTS.title}</title>
          </Helmet>
        )}
        <ConferencePageHeader
          title={'ダッシュボード'}
          middleComponent={
            usePartnerCompanyApprovalFlag && <UnapprovedWorksPageHeader />
          }
        />
        <Scroller>
          <div className='main__body'>
            <div className='dashboard'>
              <Auth
                approvedRoles={[
                  USER_ROLES.prime,
                  USER_ROLES.branch,
                  USER_ROLES.manager,
                ]}
              >
                {/* BLDE_V2-47892: 稼働日が設定されていないかBuildee利用終了日を過ぎた現場ではないなら通知は表示される */}
                {this.state.isWorkDateSet && !this.state.isFieldCompleted && (
                  <div className='dashboard__notification'>
                    <span className='dashboard__notification dashboard__notification-header'>
                      今月または来月分の稼働日が未設定です。各種設定＞稼働日より設定を行ってください。
                    </span>
                    <br />
                    ・稼働日や非稼働日は、月単位で設定する必要があります。
                    <br />
                    ・稼働日や非稼働日を設定していない月の帳票を出力した場合、日付が正しく表示されない可能性があります。
                    <br />
                    竣工までの期間については、毎月稼働日の設定をしていただくようにお願い致します。
                  </div>
                )}
              </Auth>
              <div className='dashboard__section'>
                <div className='dashboard__section-title'>現場詳細</div>
                <div className='dashboard-table'>
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <span className='label'>現場名</span>
                        </td>
                        <td className='dashboard-table__content'>
                          <span className='dashboard-table__content-inner'>
                            {fieldData.name}
                          </span>
                        </td>
                      </tr>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <span className='label'>現場住所</span>
                        </td>
                        <td className='dashboard-table__content'>
                          <span className='dashboard-table__content-inner'>
                            {fieldData.address}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='dashboard-table__blank' />
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <span className='label'>着工 - 竣工予定日</span>
                        </td>
                        <td className='dashboard-table__content'>
                          <span className='dashboard-table__content-inner'>
                            {Moment(fieldData.groundbreaking_date).format(
                              'YYYY/MM/DD(ddd)'
                            )}{' '}
                            -{' '}
                            {Moment(fieldData.complete_schedule_date).format(
                              'YYYY/MM/DD(ddd)'
                            )}
                          </span>
                        </td>
                      </tr>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <span className='label'>連絡先</span>
                        </td>
                        <td className='dashboard-table__content'>
                          <span className='dashboard-table__content-inner'>
                            {fieldData.tel}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='dashboard-table'>
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <button
                            id='accordion-toggle'
                            className={`accordion__btn${
                              isOpenListFieldFiles ? ' show' : ''
                            } dashboard-accordion__btn`}
                            onClick={() =>
                              this.handleCollapseListToggle(
                                'isOpenListFieldFiles'
                              )
                            }
                          />
                          <span className='label'>
                            {messageUtility.getMessage('I-001-588')}
                          </span>
                        </td>
                        <td className='dashboard-table__label'>
                          {this.isPrimaryCompanyRole && (
                            <button
                              className='dashboard-table__btn-icon-upload'
                              onClick={this.handleOpenDialogFieldFile}
                            />
                          )}
                        </td>
                      </tr>
                      {fieldFieldsLeftTableRows}
                    </tbody>
                  </table>
                  <div className='dashboard-table__blank' />
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr' />
                      {fieldFieldsRightTableRows}
                    </tbody>
                  </table>
                </div>
                <div className='dashboard-table'>
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr'>
                        <td className='dashboard-table__label'>
                          <button
                            id='accordion-toggle'
                            className={`accordion__btn${
                              isOpenListFieldUrls ? ' show' : ''
                            } dashboard-accordion__btn`}
                            onClick={() =>
                              this.handleCollapseListToggle(
                                'isOpenListFieldUrls'
                              )
                            }
                          />
                          <span className='label'>
                            {messageUtility.getMessage('I-001-586')}
                          </span>
                        </td>
                        <td className='dashboard-table__label'>
                          {this.isPrimaryCompanyRole && (
                            <button
                              className='dashboard-table__btn-icon'
                              onClick={this.handleOpenDialogFieldUrl}
                            />
                          )}
                        </td>
                      </tr>
                      {fieldUrlsLeftTableRows}
                    </tbody>
                  </table>
                  <div className='dashboard-table__blank' />
                  <table className='dashboard-table__table'>
                    <tbody>
                      <tr className='dashboard-table__tr' />
                      {fieldUrlsRightTableRows}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='dashboard__wrapper dashboard__wrapper--splitview'>
                <div className='dashboard__section'>
                  <div className='dashboard__section-title'>人工(人)</div>
                  <div className='dashboard__boards'>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>予定</div>
                      <div className='value'>{worker.scheduled}</div>
                    </div>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>実績</div>
                      <div className='value'>{worker.achivement}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='dashboard__section'>
                <div className='dashboard__section-title'>
                  統括安全衛生責任者 - 各種巡回連絡
                </div>
                <ul className='textlist'>
                  {_.map(this.state.patrolDataList, patrolData =>
                    this.renderPatrolLogByReportType(patrolData)
                  )}
                </ul>
              </div>
            </div>
            <Confirmation
              visible={this.state.isShowDialogFieldUrl}
              title={messageUtility.getMessage('I-001-586')}
              message={
                <FieldUrlContent
                  fieldUrlsOrigin={this.state.fieldUrlsOrigin}
                  fieldUrlsNew={this.state.fieldUrlsNew}
                  handleAddFieldUrl={this.handleAddFieldUrl}
                  handleChangeFieldUrl={this.handleChangeFieldUrl}
                  validateFieldUrl={this.validateFieldUrl}
                  handleRemoveFieldUrl={this.handleRemoveFieldUrl}
                  handleEdit={this.handleEditFieldUrl}
                  isLoading={this.state.isLoading}
                />
              }
              confirmButtonText='設定'
              effectiveButtonClassName='btn--effective--filled'
              cancelButtonText={messageUtility.getMessage('I-000-017')}
              disabledConfirmButton={this.isDisabledSubmitFieldUrls()}
              onConfirm={this.handleUpdateFieldUrl}
              onCancel={this.handleCloseDialogFieldUrl}
              rootClassName='dialog--urls'
            />
            <Confirmation
              visible={this.state.isShowDialogFilesUpload}
              title={messageUtility.getMessage('I-001-588')}
              message={
                <FieldFileContent
                  setFile={this.setFile}
                  fieldFilesNew={fieldFilesNew}
                  fieldFilesOrigin={fieldFilesOrigin}
                  handleRemoveFile={this.handleRemoveFile}
                  isLoading={this.state.isLoading}
                />
              }
              confirmButtonText='設定'
              effectiveButtonClassName='btn--effective--filled'
              cancelButtonText={messageUtility.getMessage('I-000-017')}
              onConfirm={this.handleUpdateFieldFiles}
              onCancel={this.handleCloseDialogFieldFiles}
              rootClassName='dialog--files'
            />
          </div>
        </Scroller>
      </div>
    );
  }
}

const FieldFileContent = ({
  setFile,
  fieldFilesNew,
  fieldFilesOrigin,
  handleRemoveFile,
  isLoading,
}) => {
  const fileInputRef = useRef(null);
  const isMaxFiles = _.size(fieldFilesOrigin) + _.size(fieldFilesNew) >= 10;
  const isEmptyListFiles =
    _.isEmpty(fieldFilesOrigin) && _.isEmpty(fieldFilesNew);

  if (isLoading) {
    return <div className='indicator' />;
  }

  return (
    <div className='dashboard--dialog-files'>
      {!isEmptyListFiles && (
        <div className='dashboard--dialog-files__title'>表示名</div>
      )}
      {_.map(fieldFilesOrigin, file => (
        <FileShareItem
          key={`fieldFileOrigin-${file.id}`}
          id={file.id}
          fileName={file.file_name}
          handleChangeFile={setFile}
          handleRemoveFile={handleRemoveFile}
        />
      ))}
      {_.map(fieldFilesNew, (file, index) => (
        <FileShareItem
          key={`fieldFileNew-${index}`}
          id={file.id}
          fileName={file.file_name}
          handleChangeFile={setFile}
          handleRemoveFile={handleRemoveFile}
          isNewFile={true}
        />
      ))}
      <div
        className={`dashboard--dialog-files__btn-add ${
          isMaxFiles ? 'disabled' : ''
        }`}
        onClick={() => !isMaxFiles && fileInputRef.current.click()}
      >
        <img src={IconCreate} alt='icon-create' />
        <span
          className={
            !isMaxFiles
              ? 'clickable-text'
              : 'dashboard--dialog-files__btn-add-text--disabled'
          }
        >
          追加
        </span>
      </div>
      <Box mt='8px'>Excel、PDF、画像ファイルを共有できます。</Box>
      <input
        type='file'
        className='dashboard--dialog-files--input-file'
        onChange={event => {
          setFile(event.target.files[0]);
          event.target.value = '';
        }}
        ref={fileInputRef}
      />
    </div>
  );
};

const FieldUrlContent = ({
  fieldUrlsOrigin,
  fieldUrlsNew,
  handleAddFieldUrl,
  handleChangeFieldUrl,
  handleRemoveFieldUrl,
  handleEdit,
  validateFieldUrl,
  isLoading,
}) => {
  const isMaxUrls = _.size(fieldUrlsOrigin) + _.size(fieldUrlsNew) >= 10;
  const isEmptyListUrls = _.isEmpty(fieldUrlsOrigin) && _.isEmpty(fieldUrlsNew);

  if (isLoading) {
    return <div className='indicator' />;
  }

  return (
    <div className='dashboard--dialog-urls'>
      {!isEmptyListUrls && (
        <div className='dashboard--dialog-urls__title'>表示名</div>
      )}
      <div className='dashboard--dialog-urls__list'>
        {_.map(fieldUrlsOrigin, fieldUrl => (
          <FieldUrlItem
            key={`fieldUrlOrigin-${fieldUrl.id}`}
            fieldUrl={fieldUrl}
            handleChangeFieldUrl={handleChangeFieldUrl}
            handleRemoveFieldUrl={handleRemoveFieldUrl}
            handleEdit={handleEdit}
            validateFieldUrl={validateFieldUrl}
          />
        ))}
        {_.map(fieldUrlsNew, (fieldUrl, index) => (
          <FieldUrlItem
            key={`fieldUrlNew-${index}`}
            isNewUrl
            handleChangeFieldUrl={handleChangeFieldUrl}
            handleRemoveFieldUrl={handleRemoveFieldUrl}
            handleEdit={handleEdit}
            validateFieldUrl={validateFieldUrl}
            fieldUrl={{ ...fieldUrl, id: index }}
          />
        ))}
      </div>
      <div
        className={`dashboard--dialog-urls__btn-add ${
          isMaxUrls ? 'disabled' : ''
        }`}
        onClick={() => !isMaxUrls && handleAddFieldUrl()}
      >
        <img src={IconCreate} alt='icon-create' />
        <span
          className={
            !isMaxUrls
              ? 'clickable-text'
              : 'dashboard--dialog-urls__btn-add-text--disabled'
          }
        >
          追加
        </span>
      </div>
    </div>
  );
};

const FieldUrlItem = ({
  handleChangeFieldUrl,
  handleRemoveFieldUrl,
  isNewUrl = false,
  handleEdit,
  validateFieldUrl,
  fieldUrl,
}) => {
  const {
    id,
    title,
    url,
    weather_url_flag,
    isEdited,
    errorTitle,
    errorUrl,
  } = fieldUrl;
  return (
    <Stack
      direction='row'
      spacing={1}
      paddingRight={weather_url_flag ? 4 : 0}
      className='dashboard--dialog-urls__item'
    >
      <Stack width={200}>
        <input
          className='dashboard--dialog-urls__item--input-title'
          value={title}
          onChange={event =>
            handleChangeFieldUrl(id, isNewUrl, 'title', event.target.value)
          }
          type='text'
          placeholder='表示名を入力してください。'
          maxLength={MAX_LENGTH.label}
          onBlur={event =>
            validateFieldUrl(id, isNewUrl, 'title', event.target.value)
          }
          disabled={weather_url_flag || !isEdited}
        />
        {errorTitle && isEdited && !weather_url_flag && (
          <div className='dashboard--dialog-urls__item--error'>
            {errorTitle}
          </div>
        )}
      </Stack>
      <Stack flex={1}>
        <input
          className='dashboard--dialog-urls__item--input-url'
          value={url}
          onChange={event =>
            handleChangeFieldUrl(id, isNewUrl, 'url', event.target.value)
          }
          type='text'
          maxLength={MAX_LENGTH.url}
          placeholder='URLを入力してください。'
          disabled={!isEdited}
          onBlur={event =>
            validateFieldUrl(id, isNewUrl, 'url', event.target.value)
          }
        />
        {errorUrl && (
          <div className='dashboard--dialog-urls__item--error'>{errorUrl}</div>
        )}
      </Stack>
      <button
        className={`icon-button icon-button--edit ${
          isEdited ? 'icon-button--disabled' : ''
        }`}
        onClick={() => !isEdited && handleEdit(id)}
      />
      {!weather_url_flag && (
        <button
          className='icon-button icon-button--trash'
          onClick={() => handleRemoveFieldUrl(id, isNewUrl)}
        />
      )}
    </Stack>
  );
};

const WrappedImageDialog = props => (
  <CommonModal visible>
    <ImageDialog {...props} />
  </CommonModal>
);

const FileShareItem = ({
  id,
  fileName,
  isNewFile = false,
  handleChangeFile,
  handleRemoveFile,
}) => {
  const fileRef = useRef(null);
  const filenameTail = fileName.slice(FILE_NAME_TAIL);
  const fileNameRemaining = fileName.slice(0, FILE_NAME_TAIL);

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      className='dashboard--dialog-files__item'
      spacing={1}
    >
      <Box
        display='flex'
        maxWidth='100%'
        whiteSpace='pre'
        className='dashboard--dialog-files__item-name'
      >
        <span className='nowrap file-name-pre'>{fileNameRemaining}</span>
        {filenameTail}
      </Box>
      <Stack direction='row' spacing={1}>
        <button
          className='icon-button icon-button--upload'
          onClick={() => {
            fileRef.current.click();
          }}
        />
        <button
          className='icon-button icon-button--trash'
          onClick={() => handleRemoveFile(id, isNewFile)}
        />
      </Stack>
      <input
        type='file'
        ref={fileRef}
        className='dashboard--dialog-files--input-file'
        onChange={event => {
          handleChangeFile(event.target.files[0], isNewFile, id);
          event.target.value = '';
        }}
      />
    </Stack>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Dashboard.jsx